export default "__VITE_ASSET__Brw7RPgp__"